import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as LeftArrowSvg } from "../svgs/LeftArrow.svg";
import { ReactComponent as RightArrowSvg } from "../svgs/RightArrow.svg";
import imgTimGinny from "../images/06b8bb75725251.5c54659ef1aff.jpg";
import imgChouWen from "../images/c7c7cf130801465.61884f3bcc3ba.jpg";
import imgDannyFangJu from "../images/74db5b179088259.65cbc9a362722.jpg";
import { Typography } from "@mui/material";

const words = [
  {
    desc: "CK did a fantastic job in our wedding. He is very professional, and has a perfectionist attitude that he even visited the venue together with us before the big day to give us suggestions on where we should be taking pictures and have the send-off moment. The results were amazing and I’m truly thankful that we chose him as our photographer for the most special day of our lives.",
    author: "Tim & Ginny",
    img: imgTimGinny,
  },
  {
    desc: "We are happy to have CK take our pre-wedding photos. He is not only experienced in capturing our emotions but also great at making the best use of surrounding and natural light. It was a great experience to plan the photo shoot together. We had rough ideas for the style, outfits, and scenes. During the pre-shooting discussion session, CK provided us with practical advice on how to match our outfits with site locations and different lights during the day. The photo-shooting day was also a great fun. CK is professional, and his assistant helped us a lot as well. We enjoy their company and love our photos.",
    author: "Yu Chou & Yu Wen",
    img: imgChouWen,
  },
  {
    desc: "CK is amazing! Having him on our wedding day was wonderful. We couldn't be happier with the results. He pays attention to the details of the wedding day and the planning process. He captured all the happy and loving moments, and his photos have the magic of bringing back all the memories. Looking at these photos brings us back to the wedding day. I highly recommend CK if you're looking for a professional and caring photographer.",
    author: "Danny & Fang Ju",
    img: imgDannyFangJu,
  },
];

export default function Recommendation() {
  const theme = useTheme();
  const [rotatingStart, setRotatingStart] = useState(false);
  const [id, setId] = useState(0);

  const onLeftBtnClick = () => {
    const newId = (id - 1) % words.length;
    console.debug(newId);
    setId(newId === -1 ? words.length - 1 : newId);
  };

  const onRightBtnClick = () => {
    setId((id + 1) % words.length);
  };

  useEffect(() => {
    if (!rotatingStart) {
      setInterval(() => {
        setId((prevState) => (prevState + 1) % words.length);
      }, 20000);
      setRotatingStart(true);
    }
  }, [rotatingStart]);

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        pt: { xs: theme.spacing(5), md: theme.spacing(10) },
        pb: { xs: theme.spacing(5), md: theme.spacing(10) },
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width={{ xs: "85%", md: "65%" }}
        flexDirection={{ xs: "column", md: "row" }}
        sx={{
          backgroundColor: "rgba(244,242,238,1)",
        }}
      >
        <Box width={{ xs: "80%", md: "50%" }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            pl={{ md: theme.spacing(5) }}
            pt={theme.spacing(5)}
            sx={{
              fontSize: { xs: "0.8rem", md: "0.9rem" },
            }}
          >
            <Typography variant="h5" fontWeight={550}>
              {`${words[id].author}`}
            </Typography>
            <p>
              <i>{`“${words[id].desc}”`}</i>
            </p>
            <Box pt={"3px"} pb={"3px"}>
              <IconButton style={{ padding: "12px" }} onClick={onLeftBtnClick}>
                <SvgIcon>
                  <LeftArrowSvg />
                </SvgIcon>
              </IconButton>
              <IconButton style={{ padding: "12px" }} onClick={onRightBtnClick}>
                <SvgIcon>
                  <RightArrowSvg />
                </SvgIcon>
              </IconButton>
            </Box>
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          pt={theme.spacing(3)}
          pb={{ xs: theme.spacing(5), md: 0 }}
          mb={{ xs: 0, md: theme.spacing(-5) }}
          width={{ xs: "100%", md: "50%" }}
          sx={{
            opacity: 0.9,
          }}
        >
          <img
            width="70%"
            height="auto"
            src={words[id].img}
            alt="profile"
          ></img>
        </Box>
      </Box>
    </Box>
  );
}
